module.exports = __webpack_public_path__ + "static/media/logopwa.1f441cb9.png";